import { getApiKey } from "../../utils/apiKey";
import React, { Component } from "react";
import { apiCall_domain, token } from "../api";
import axios from "axios";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { createGlobalStyle } from "styled-components";
import Header from "../header";
import SimpleReactValidator from "simple-react-validator";
import PulseLoader from "react-spinners/PulseLoader";
export default class addCars extends Component {
  constructor() {
    super();
    this.state = {
      car: {
        name: "",
        brand: "",
        car: "",
        model: "",
        type: "",
      },
      brands: [],
      loading: false,
      forceUpdate: false,
    };
    this.validator = new SimpleReactValidator({
      className: "error",
      messages: {
        required: "این فیلد الزامی است",
      },
    });
  }

  componentDidMount() {
    const headers = {
      Authorization: getApiKey() || token(),
      "content-type": "application/json",
    };
    axios
      .get(`${apiCall_domain}/customer/car-types`, {
        headers,
      })
      .then((res) => {
        this.setState({ brands: res.data.data });
      });
  }

  changeField = ({ target }) => {
    this.setState({ car: { ...this.state.car, [target.name]: target.value } });
  };
  submit = () => {
    this.setState({ forceUpdate: !this.state.forceUpdate });
    if (this.validator.allValid() && !this.state.loading) {
      this.setState({ loading: true }, () => {
        const headers = {
          Authorization: getApiKey(),
          "content-type": "application/json",
        };
        const data = {
          car_id: this.state.car.car.id,
          name: this.state.car.name,
          type_id: this.state.car.type.id,
        };
        axios
          .post(`${apiCall_domain}/customer/user/cars`, data, {
            headers: headers,
          })
          .then((res) => {
            if (res.status === 201) {
              this.props.history.push("/Search");
            }
          });
      });
    } else {
      this.validator.showMessages();
    }
  };
  render() {
    const GlobalStyles = createGlobalStyle`body{
            background: #F9F9F9;
          }`;
    return (
      <>
        <GlobalStyles />
        <Header showSearchBar={true} title={"افزودن خودروی جدید"} />
        <div className="addCar">
          <div className="AddCarBody">
            <div className="selectControl">
              <span className="Text">اسم دلخواه</span>
              <input
                className="filter_dataReceiver"
                placeholder="نام خودرو (مثلا خودرو خودم)"
                onChange={this.changeField}
                name="name"
                value={this.state.car.name}
              />
              {this.validator.message("type", this.state.car.name, "required")}
            </div>
            <div className="selectControl">
              <FormControl>
                <span className="Text">برند ماشین</span>
                <Select
                  value={this.state.car.brand}
                  onChange={this.changeField}
                  name="brand"
                  displayEmpty
                >
                  <MenuItem value="">
                    <em className="emSelect">برند ماشین خود را انتخاب کنید</em>
                  </MenuItem>
                  {this.state.brands.map((brand) => (
                    <MenuItem key={brand.id} value={brand}>
                      {brand.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {this.validator.message("type", this.state.car.brand, "required")}
            </div>
            <div className="selectControl">
              <FormControl>
                <span className="Text">نام ماشین </span>
                <Select
                  value={this.state.car.car}
                  onChange={this.changeField}
                  name="car"
                  displayEmpty
                >
                  <MenuItem value="">
                    <em className="emSelect">نام ماشین خود را انتخاب کنید</em>
                  </MenuItem>
                  {this.state.car.brand?.cars?.map((car) => (
                    <MenuItem key={car.id} value={car}>
                      {car.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {this.validator.message("type", this.state.car.car, "required")}
            </div>
            <div className="selectControl">
              <FormControl>
                <span className="Text">تیپ (اختیاری)</span>
                <Select
                  value={this.state.car.type}
                  onChange={this.changeField}
                  name="type"
                  displayEmpty
                >
                  <MenuItem value="">
                    <em className="emSelect">تیپ ماشین خود را انتخاب کنید</em>
                  </MenuItem>
                  {this.state.car.car?.types?.map((type) => (
                    <MenuItem key={type.id} value={type}>
                      {type.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {this.validator.message("type", this.state.car.type, "required")}
            </div>
          </div>
          <div className="filters_button_wrapper">
            <button className="btn" onClick={this.submit}>
              {this.state.loading ? (
                <PulseLoader color="#fff" size={10} />
              ) : (
                "ذخیره خودرو"
              )}
            </button>
          </div>
        </div>
      </>
    );
  }
}
